// src/Components/ParameterTabs/ParameterTabs.js
import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Form } from 'react-bootstrap';
import ParameterCard from '../ParameterCard/ParameterCard';
import './ParameterTabs.css';

const ParameterTabs = ({
  parameterGroups,
  selectedValues,
  setSelectedValues,
  activeKey,
  handleTabSelect,
  handleValueChange,
  parameterOptions
}) => {
  const [useAdvancedTime, setUseAdvancedTime] = useState(false);
  const toggleAdvancedTime = () => setUseAdvancedTime(prev => !prev);

  // Pre-select dynamicTime on enable
  useEffect(() => {
    if (useAdvancedTime) {
      const timeGroup = parameterGroups.find(g => g.name.toUpperCase() === 'TIME');
      if (timeGroup) {
        const dyn = timeGroup.parameters.find(p => p.type === 'dateRange');
        if (dyn) {
          handleValueChange({ id: dyn.id, name: dyn.name }, '');
        }
      }
    }
  }, [useAdvancedTime, parameterGroups, handleValueChange]);

  return (
    <div className='parameter-tabs d-flex flex-column flex-grow-1'>
      <Tabs
        id='parameter-tabs'
        activeKey={activeKey}
        onSelect={k => handleTabSelect(+k)}
        className='main-tabs'
        justify
      >
        {parameterGroups.map((group, ix) => (
          <Tab title={group.name.toUpperCase()} eventKey={ix} key={group.id}>
            <div className='parameter-cards h-100 overflow-y-auto flex-grow-1 d-flex justify-content-around flex-wrap w-100'>
              {group.name.toUpperCase() === 'TIME' && (
                <div className='w-100 d-flex justify-content-start mb-3 px-3'>
                  <Form.Check
                    inline
                    type='switch'
                    label='Use Dynamic Time Selection'
                    checked={useAdvancedTime}
                    onChange={toggleAdvancedTime}
                    className=''
                  />
                </div>
              )}

              {group.parameters
                .filter(param => {
                  if (group.name.toUpperCase() === 'TIME') {
                    const isRange = param.type === 'dynamicDateRange';
                    return useAdvancedTime ? isRange : !isRange;
                  }
                  return true;
                })
                .map(param => (
                  <ParameterCard
                    key={param.id}
                    parameter={param}
                    selectedValues={selectedValues}
                    setSelectedValues={handleValueChange}
                    values={parameterOptions[param.id] || []}
                  />
                ))}
            </div>
          </Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default ParameterTabs;
